import { Box } from '@mantine/core'
import React from 'react'

import classes from './Page.module.scss'

export function PageContent({ children }: { children: React.ReactNode }) {
  return <Box className={classes.PageContentWrapper}>{children}</Box>
}
